<template>
	<section :class="['info-cards-overlap', classes]">
		<div class="container px-0-lg">
			<article
				v-for="(card, index) in cards"
				:key="index"
				class="info-card display-flex-md align-items-center-md position-relative"
			>
				<div
					v-reveal:fade-up
					role="presentation"
					class="col-8-md info-card-image aspect-ratio-16-9-smo"
					:style="`background-image: url(${card.imageUrl})`"
				></div>
				<div class="col-7-md col-5-lg info-card-content">
					<p v-if="card.heading" class="overline mb-100">
						{{ card.heading }}
					</p>
					<h3 class="heading-1">
						{{ card.title }}
					</h3>
					<p
						v-for="(desc, descId) in card.description"
						:key="descId"
						class="delta-lg line-height-150"
						v-html="desc"
					></p>
					<BaseCtaLink
						v-if="card.link"
						:link="card.link"
						classes="body-md body-lg-lg display-inline-block mt-200"
						icon="arrow"
					/>
				</div>
			</article>
		</div>
	</section>
</template>

<script setup lang="ts">
import { InfoCard } from 'types/layout';

interface Props {
	cards: Array<InfoCard>;
	classes?: string;
}

withDefaults(defineProps<Props>(), {
	classes: ''
});
</script>
<style lang="scss" scoped>
@use '../../styles/constants/colors' as *;
@use '../../styles/utilities/respond-to.scss' as *;

.info-cards-overlap {
	.info-card {
		&:not(:last-child) {
			@include respond-to(smo) {
				padding-bottom: 4rem;
			}
		}

		&:nth-of-type(odd) {
			&:not(:last-child) {
				@include respond-to(md) {
					margin-bottom: 2rem;
				}
			}
		}

		&:nth-of-type(even) {
			&:not(:last-child) {
				@include respond-to(md) {
					margin-bottom: 8rem;
				}
			}

			@include respond-to(md) {
				flex-direction: row-reverse;

				.info-card-image {
					bottom: 0;
					left: 0;
					right: auto;
					top: auto;
				}

				.info-card-content {
					margin: 6rem 0 -3rem;
				}
			}
		}

		&-image {
			background-color: token('content-primary');
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;

			@include respond-to(md) {
				height: calc(100% - 3rem);
				position: absolute;
				right: 0;
				top: 0;
			}
		}

		&-content {
			background-color: white;
			margin: -6rem 1rem 0;
			padding: 2rem;
			position: relative;

			@include respond-to(md) {
				margin: 3rem 0 0;
				padding: 3rem;
			}
		}
	}
}
</style>
